<main class="about">
  <app-header></app-header>
  <section class="about__organization-info">
    <div class="component-content" [innerHTML]="jds"></div>
  </section>
  <!--
  <app-vacancies></app-vacancies>
 -->
  <app-footer></app-footer>
</main>